export enum PayerActionDispatchTypes {
  PAYER_INVOKE = "PAYER_INVOKE",
  PAYER_SUCCESS = "PAYER_SUCCESS",
  PAYER_ERROR = "PAYER_ERROR",
}

export enum MasterCallOutcomeActionDispatchTypes {
  MASTER_CALLOUTCOME_INVOKE = "MASTER_CALLOUTCOME_INVOKE",
  MASTER_CALLOUTCOME_SUCCESS = "MASTER_CALLOUTCOME_SUCCESS",
  MASTER_CALLOUTCOME_ERROR = "MASTER_CALLOUTCOME_ERROR",
}

export enum IcdCodeTypeActionDispatchTypes {
  GET_ICD_CODE_TYPE_INVOKE = "GET_ICD_CODE_TYPE_INVOKE",
  GET_ICD_CODE_TYPE_SUCCESS = "GET_ICD_CODE_TYPE_SUCCESS",
  GET_ICD_CODE_TYPE_ERROR = "GET_ICD_CODE_TYPE_ERROR",
}

export enum DiseaseTypeActionDispatchTypes {
  GET_DISEASE_TYPE_INVOKE = "GET_DISEASE_TYPE_INVOKE",
  GET_DISEASE_TYPE_SUCCESS = "GET_DISEASE_TYPE_SUCCESS",
  GET_DISEASE_TYPE_ERROR = "GET_DISEASE_TYPE_ERROR",
}

export enum HealthProgramActionDispatchTypes {
  GET_HEALTH_PROGRAM_INVOKE = "GET_HEALTH_PROGRAM_INVOKE",
  GET_HEALTH_PROGRAM_SUCCESS = "GET_HEALTH_PROGRAM_SUCCESS",
  GET_HEALTH_PROGRAM_ERROR = "GET_HEALTH_PROGRAM_ERROR",
}

export enum CareCoordinationProgramActionDispatchTypes {
  GET_CARECORDINATION_PROGRAM_INVOKE = "GET_CARECORDINATION_PROGRAM_INVOKE",
  GET_CARECORDINATION_PROGRAM_SUCCESS = "GET_CARECORDINATION_PROGRAM_SUCCESS",
  GET_CARECORDINATION_PROGRAM_ERROR = "GET_CARECORDINATION_PROGRAM_ERROR",
}

export enum NonCoveredServicesActionDispatchTypes {
  GET_NONCOVERED_SERVICES_INVOKE = "GET_NONCOVERED_SERVICES_INVOKE",
  GET_NONCOVERED_SERVICES_SUCCESS = "GET_NONCOVERED_SERVICES_SUCCESS",
  GET_NONCOVERED_SERVICES_ERROR = "GET_NONCOVERED_SERVICES_ERROR",
}

export enum OrderingSourceActionDispatchTypes {
  GET_ORDERING_SOURCE_INVOKE = "GET_ORDERING_SOURCE_INVOKE",
  GET_ORDERING_SOURCE_SUCCESS = "GET_ORDERING_SOURCE_SUCCESS",
  GET_ORDERING_SOURCE_ERROR = "GET_ORDERING_SOURCE_ERROR",
}

export enum OrderAcceptorActionDispatchTypes {
  GET_ORDER_ACCEPTOR_INVOKE = "GET_ORDER_ACCEPTOR_INVOKE",
  GET_ORDER_ACCEPTOR_SUCCESS = "GET_ORDER_ACCEPTOR_SUCCESS",
  GET_ORDER_ACCEPTOR_ERROR = "GET_ORDER_ACCEPTOR_ERROR",
}

export enum DisciplinesActionDispatchTypes {
  DISCIPLINES_INVOKE = "DISCIPLINES_INVOKE",
  DISCIPLINES_SUCCESS = "DISCIPLINES_SUCCESS",
  DISCIPLINES_RESET = "DISCIPLINES_RESET",
  DISCIPLINES_ERROR = "DISCIPLINES_ERROR",
}

export enum CareTypeActionDispatchTypes {
  CARE_TYPE_INVOKE = "CARE_TYPE_INVOKE",
  CARE_TYPE_SUCCESS = "CARE_TYPE_SUCCESS",
  CARE_TYPE_ERROR = "CARE_TYPE_ERROR",
}

export enum PastMedicalHistoryActionDispatchTypes {
  PAST_MEDICAL_HISTORY_INVOKE = "PAST_MEDICAL_HISTORY_INVOKE",
  PAST_MEDICAL_HISTORY_SUCCESS = "PAST_MEDICAL_HISTORY_SUCCESS",
  PAST_MEDICAL_HISTORY_ERROR = "PAST_MEDICAL_HISTORY_ERROR",
}
export enum PsychologicalHistoryActionDispatchTypes {
  PSYCHOLOGICAL_HISTORY_INVOKE = "PSYCHOLOGICAL_HISTORY_INVOKE",
  PSYCHOLOGICAL_HISTORY_SUCCESS = "PSYCHOLOGICAL_HISTORY_SUCCESS",
  PSYCHOLOGICAL_HISTORY_ERROR = "PSYCHOLOGICAL_HISTORY_ERROR",
}

export enum DocumentActionDispatchTypes {
  MASTER_DOCUMENT_INVOKE = "MASTER_DOCUMENT_INVOKE",
  MASTER_DOCUMENT_SUCCESS = "MASTER_DOCUMENT_SUCCESS",
}

export enum AuthorizationStatusActionDispatchTypes {
  AUTHORIZATION_STATUS_INVOKE = "AUTHORIZATION_STATUS_INVOKE",
  AUTHORIZATION_STATUS_SUCCESS = "AUTHORIZATION_STATUS_SUCCESS",
  AUTHORIZATION_STATUS_ERROR = "AUTHORIZATION_STATUS_ERROR",
}

export enum PriorAuthReferralSourceActionDispatchTypes {
  PRIOR_AUTH_REFERRAL_SOURCE_INVOKE = "PRIOR_AUTH_REFERRAL_SOURCE_INVOKE",
  PRIOR_AUTH_REFERRAL_SOURCE_SUCCESS = "PRIOR_AUTH_REFERRAL_SOURCE_SUCCESS",
  PRIOR_AUTH_REFERRAL_SOURCE_ERROR = "PRIOR_AUTH_REFERRAL_SOURCE_ERROR",
}

export enum ReAuthReferralSourceActionDispatchTypes {
  RE_AUTH_REFERRAL_SOURCE_INVOKE = "RE_AUTH_REFERRAL_SOURCE_INVOKE",
  RE_AUTH_REFERRAL_SOURCE_SUCCESS = "RE_AUTH_REFERRAL_SOURCE_SUCCESS",
  RE_AUTH_REFERRAL_SOURCE_ERROR = "RE_AUTH_REFERRAL_SOURCE_ERROR",
}

export enum StaffingStatusActionDispatchTypes {
  STAFFING_STATUS_INVOKE = "STAFFING_STATUS_INVOKE",
  STAFFING_STATUS_SUCCESS = "STAFFING_STATUS_SUCCESS",
  STAFFING_STATUS_ERROR = "STAFFING_STATUS_ERROR",
}

export enum DischargeReasonActionDispatchTypes {
  DISCHARGE_REASON_INVOKE = "DISCHARGE_REASON_INVOKE",
  DISCHARGE_REASON_SUCCESS = "DISCHARGE_REASON_SUCCESS",
  DISCHARGE_REASON_ERROR = "DISCHARGE_REASON_ERROR",
}
export enum DocumentTypeActionDispatchTypes {
  GET_DOCUMENT_TYPE_INVOKE = "GET_DOCUMENT_TYPE_INVOKE",
  GET_DOCUMENT_TYPE_SUCCESS = "GET_DOCUMENT_TYPE_SUCCESS",
  GET_DOCUMENT_TYPE_ERROR = "GET_DOCUMENT_TYPE_ERROR",
  GET_DOCUMENT_TYPE_RESET = "GET_DOCUMENT_TYPE_RESET",
}

export enum DocumentTypeForPriorAuthActionDispatchTypes {
  GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_INVOKE = "GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_INVOKE",
  GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_SUCCESS = "GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_SUCCESS",
  GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_RESET = "GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_RESET",
  GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_ERROR = "GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_ERROR",
}

export enum DocumentSourceActionDispatchTypes {
  GET_DOCUMENT_SOURCE_INVOKE = "GET_DOCUMENT_SOURCE_INVOKE",
  GET_DOCUMENT_SOURCE_SUCCESS = "GET_DOCUMENT_SOURCE_SUCCESS",
  GET_DOCUMENT_SOURCE_ERROR = "GET_DOCUMENT_SOURCE_ERROR",
  GET_DOCUMENT_SOURCE_RESET = "GET_DOCUMENT_SOURCE_RESET",
}

export enum DocumentSourceForFilterActionDispatchTypes {
  GET_DOCUMENT_SOURCE_FOR_FILTER_INVOKE = "GET_DOCUMENT_SOURCE_FOR_FILTER_INVOKE",
  GET_DOCUMENT_SOURCE_FOR_FILTER_SUCCESS = "GET_DOCUMENT_SOURCE_FOR_FILTER_SUCCESS",
  GET_DOCUMENT_SOURCE_FOR_FILTER_RESET = "GET_DOCUMENT_SOURCE_FOR_FILTER_RESET",
}

export enum CreatedByActionDispatchTypes {
  CREATED_BY_INVOKE = "CREATED_BY_INVOKE",
  CREATED_BY_SUCCESS = "CREATED_BY_SUCCESS",
  CREATED_BY_ERROR = "CREATED_BY_ERROR",
}

export enum ReferralServiceStatusActionDispatchTypes {
  REFERRAL_SERVICE_STATUS_INVOKE = "REFERRAL_SERVICE_STATUS_INVOKE",
  REFERRAL_SERVICE_STATUS_SUCCESS = "REFERRAL_SERVICE_STATUS_SUCCESS",
  REFERRAL_SERVICE_STATUS_RESET = "REFERRAL_SERVICE_STATUS_RESET",
  REFERRAL_SERVICE_STATUS_ERROR = "REFERRAL_SERVICE_STATUS_ERROR",
}

export enum ServiceStatusMasterActionDispatchTypes {
  SERVICE_STATUS_MASTER_INVOKE = "SERVICE_STATUS_MASTER_INVOKE",
  SERVICE_STATUS_MASTER_SUCCESS = "SERVICE_STATUS_MASTER_SUCCESS",
  SERVICE_STATUS_MASTER_RESET = "SERVICE_STATUS_MASTER_RESET",
  SERVICE_STATUS_MASTER_ERROR = "SERVICE_STATUS_MASTER_ERROR",
}

export enum ServiceStatusReasonActionDispatchTypes {
  SERVICE_REASON_STATUS_INVOKE = "SERVICE_REASON_STATUS_INVOKE",
  SERVICE_REASON_STATUS_SUCCESS = "SERVICE_REASON_STATUS_SUCCESS",
  SERVICE_REASON_STATUS_RESET = "SERVICE_REASON_STATUS_RESET",
  SERVICE_REASON_STATUS_ERROR = "SERVICE_REASON_STATUS_ERROR",
}

export enum DisciplineTypeActionDispatchTypes {
  DISCIPLINE_TYPE_INVOKE = "DISCIPLINE_TYPE_INVOKE",
  DISCIPLINE_TYPE_SUCCESS = "DISCIPLINE_TYPE_SUCCESS",
  DISCIPLINE_TYPE_ERROR = "DISCIPLINE_TYPE_ERROR",
}

export enum ServiceStatusActionDispatchTypes {
  SERVICE_STATUS_INVOKE = "SERVICE_STATUS_INVOKE",
  SERVICE_STATUS_SUCCESS = "SERVICE_STATUS_SUCCESS",
  SERVICE_STATUS_ERROR = "SERVICE_STATUS_ERROR",
}

export enum DisciplineTemplateActionDispatchTypes {
  DISCIPLINE_TEMPLATE_INVOKE = "DISCIPLINE_TEMPLATE_INVOKE",
  DISCIPLINE_TEMPLATE_SUCCESS = "DISCIPLINE_TEMPLATE_SUCCESS",
  DISCIPLINE_TEMPLATE_ERROR ="DISCIPLINE_TEMPLATE_ERROR",
}

export enum DisciplineRequestorActionDispatchTypes {
  DISCIPLINE_REQUESTOR_INVOKE = "DISCIPLINE_REQUESTOR_INVOKE",
  DISCIPLINE_REQUESTOR_SUCCESS = "DISCIPLINE_REQUESTOR_SUCCESS",
  DISCIPLINE_REQUESTOR_ERROR = "DISCIPLINE_REQUESTOR_ERROR",
}

export enum ClinicalGroupActionDispatchTypes {
  CLINICAL_GROUP_INVOKE = "CLINICAL_GROUP_INVOKE",
  CLINICAL_GROUP_SUCCESS = "CLINICAL_GROUP_SUCCESS",
  CLINICAL_GROUP_ERROR = "CLINICAL_GROUP_ERROR",
}
export enum EligibilityRecordActionDispatchTypes {
  ELIGIBILITY_RECORD_ERROR = "ELIGIBILITY_RECORD_ERROR",
  ELIGIBILITY_RECORD_INVOKE = "ELIGIBILITY_RECORD_INVOKE",
  ELIGIBILITY_RECORD_SUCCESS = "ELIGIBILITY_RECORD_SUCCESS",
  ELIGIBILITY_RECORD_RESET = "ELIGIBILITY_RECORD_RESET",
}

export enum NotesApprovalStatusMasterActionDispatchTypes {
  NOTES_APPROVAL_STATUS_MASTER_INVOKE = "NOTES_APPROVAL_STATUS_MASTER_INVOKE",
  NOTES_APPROVAL_STATUS_MASTER_SUCCESS = "NOTES_APPROVAL_STATUS_MASTER_SUCCESS",
}

export enum ServiceRequestType {
  AUTH_ID = 1,
  RE_AUTH_ID = 2,
}

export enum HealthPlanActionDispatchTypes {
  HEALTH_PLAN_MASTER_INVOKE = "HEALTH_PLAN_MASTER_INVOKE",
  HEALTH_PLAN_MASTER_SUCCESS = "HEALTH_PLAN_MASTER_SUCCESS",
  HEALTH_PLAN_MASTER_RESET = "HEALTH_PLAN_MASTER_RESET",
  HEALTH_PLAN_MASTER_ERROR = "HEALTH_PLAN_MASTER_ERROR"
}

export const FilterByState = [
  {
    label: "",
    value: "",
  },
];

export enum BenefitPlanDetailsMasterActionDispatchTypes {
  BENEFIT_PLAN_DETAILS_MASTER_INVOKE = "BENEFIT_PLAN_DETAILS_MASTER_INVOKE",
  BENEFIT_PLAN_DETAILS_MASTER_SUCCESS = "BENEFIT_PLAN_DETAILS_MASTER_SUCCESS", 
  BENEFIT_PLAN_DETAILS_MASTER_RESET = "BENEFIT_PLAN_DETAILS_MASTER_RESET", 
  BENEFIT_PLAN_DETAILS_MASTER_ERROR = "BENEFIT_PLAN_DETAILS_MASTER_ERROR" 
}

export enum BenefitPlanStateMasterActionDispatchTypes {
  BENEFIT_PLAN_STATE_MASTER_INVOKE = "BENEFIT_PLAN_STATE_MASTER_INVOKE",
  BENEFIT_PLAN_STATE_MASTER_SUCCESS = "BENEFIT_PLAN_STATE_MASTER_SUCCESS",
  BENEFIT_PLAN_STATE_MASTER_ERROR = "BENEFIT_PLAN_STATE_MASTER_ERROR",
}

export enum AllServiceStatusReasonMasterActionDispatchTypes {
  ALL_SERVICE_STATUS_REASON_INVOKE = "ALL_SERVICE_STATUS_REASON_INVOKE",
  ALL_SERVICE_STATUS_REASON_SUCCESS = "ALL_SERVICE_STATUS_REASON_SUCCESS",
}

export enum LanguageMasterActionDispatchTypes {
  LANGUAGE_MASTER_INVOKE = "LANGUAGE_MASTER_INVOKE",
  LANGUAGE_MASTER_SUCCESS = "LANGUAGE_MASTER_SUCCESS",
  LANGUAGE_MASTER_ERROR = "LANGUAGE_MASTER_ERROR",
}

export enum AccomodationMasterActionDispatchTypes {
  ACCOMODATION_MASTER_INVOKE = "ACCOMODATION_MASTER_INVOKE",
  ACCOMODATION_MASTER_SUCCESS = "ACCOMODATION_MASTER_SUCCESS",
  ACCOMODATION_MASTER_ERROR = "ACCOMODATION_MASTER_ERROR",
}

export enum AgencyCommunicationMasterActionDispatchTypes {
  GET_AGENCY_COMMUNICATION_TEMPLATE_INVOKE = "GET_AGENCY_COMMUNICATION_TEMPLATE_INVOKE",
  GET_AGENCY_COMMUNICATION_TEMPLATE_SUCCESS = "GET_AGENCY_COMMUNICATION_TEMPLATE_SUCCESS",
  GET_AGENCY_COMMUNICATION_TEMPLATE_ERROR = "GET_AGENCY_COMMUNICATION_TEMPLATE_ERROR"
}

export const PENDING_SERVICE_STATUS_ID = 1;

export enum NtuReasonMasterActionDispatchTypes {
  GET_NTU_REASON_INVOKE = "GET_NTU_REASON_INVOKE",
  GET_NTU_REASON_SUCCESS = "GET_NTU_REASON_SUCCESS",
  GET_NTU_REASON_ERROR = "GET_NTU_REASON_ERROR",
}

export enum AuthorizationTypeMasterActionDispatchTypes {
  GET_AUTHORIZATION_TYPE_INVOKE = "GET_AUTHORIZATION_TYPE_INVOKE",
  GET_AUTHORIZATION_TYPE_SUCCESS = "GET_AUTHORIZATION_TYPE_SUCCESS",
  GET_AUTHORIZATION_TYPE_ERROR = "GET_AUTHORIZATION_TYPE_ERROR",
}

export enum ServiceStatusValue {
  Pending = 1,
  Approved = 2,
  Partially_Approved = 3,
  Denied = 4,
  Withdrawal = 5,
  Cancel = 6,
}

export enum FaxFormMasterActionDispatchTypes {
  GET_FAX_FORM_MASTER_INVOKE = "GET_FAX_FORM_MASTER_INVOKE",
  GET_FAX_FORM_MASTER_SUCCESS = "GET_FAX_FORM_MASTER_SUCCESS",
  GET_FAX_FORM_MASTER_ERROR = "GET_FAX_FORM_MASTER_ERROR",
}

export enum FaxFormOptionMasterActionDispatchTypes {
  GET_FAX_FORM_OPTION_MASTER_INVOKE = "GET_FAX_FORM_OPTION_MASTER_INVOKE",
  GET_FAX_FORM_OPTION_MASTER_SUCCESS = "GET_FAX_FORM_OPTION_MASTER_SUCCESS",
  GET_FAX_FORM_OPTION_MASTER_RESET = "GET_FAX_FORM_OPTION_MASTER_RESET",
  GET_FAX_FORM_OPTION_MASTER_ERROR ="GET_FAX_FORM_OPTION_MASTER_ERROR"
}

export enum LetterCopyTypeMasterActionDispatchTypes {
  GET_LETTER_COPY_TYPE_MASTER_INVOKE = "GET_LETTER_COPY_TYPE_MASTER_INVOKE",
  GET_LETTER_COPY_TYPE_MASTER_SUCCESS = "GET_LETTER_COPY_TYPE_MASTER_SUCCESS",
  GET_LETTER_COPY_TYPE_MASTER_ERROR = "GET_LETTER_COPY_TYPE_MASTER_ERROR",
}

export enum ServiceRequestNumberMasterActionDispatchTypes {
  GET_SERVICE_REQUEST_NUMBER_MASTER_INVOKE = "GET_SERVICE_REQUEST_NUMBER_MASTER_INVOKE",
  GET_SERVICE_REQUEST_NUMBER_MASTER_SUCCESS = "GET_SERVICE_REQUEST_NUMBER_MASTER_SUCCESS",
  GET_SERVICE_REQUEST_NUMBER_MASTER_ERROR = "GET_SERVICE_REQUEST_NUMBER_MASTER_ERROR",
}

export enum ReferralManagementSystemActionDispatchTypes {
  GET_REFERRAL_MANAGEMENT_SYSTEM_INVOKE = "GET_REFERRAL_MANAGEMENT_SYSTEM_INVOKE",
  GET_REFERRAL_MANAGEMENT_SYSTEM_SUCCESS = "GET_REFERRAL_MANAGEMENT_SYSTEM_SUCCESS",
  GET_REFERRAL_MANAGEMENT_SYSTEM_ERROR = "GET_REFERRAL_MANAGEMENT_SYSTEM_ERROR",
}

export enum MasterSyncActionDispatchTypes {
  MASTER_SYNC_ERROR = "MASTER_SYNC_ERROR",
  MASTER_SYNC_INVOKE = "MASTER_SYNC_INVOKE",
  MASTER_SYNC_SUCCESS = "MASTER_SYNC_SUCCESS",
  MASTER_SYNC_RESET = "MASTER_SYNC_RESET",
}

export const CreatedByNotesType = {
  Referral : "1",
  Document : "2"
}

export enum RelationshipTypeMasterActionDispatchTypes {
  RELATIONSHIP_TYPE_MASTER_INVOKE = "RELATIONSHIP_TYPE_MASTER_INVOKE",
  RELATIONSHIP_TYPE_MASTER_SUCCESS = "RELATIONSHIP_TYPE_MASTER_SUCCESS",
  RELATIONSHIP_TYPE_MASTER_ERROR = "RELATIONSHIP_TYPE_MASTER_ERROR",
}

export enum PayerId {
  BCBS_MICHIGAN_PAYERID = "00710",
  BCBS_TN_PAYERID = "SB890"
}